/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type DevelopmentRegistrationStep = "first_buyer" | "result" | "second_buyer" | "verification";
export type LotCurrency = "CHF" | "EUR" | "GBP";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentFirstBuyerStep_form$ref: FragmentReference;
declare export opaque type DevelopmentFirstBuyerStep_form$fragmentType: DevelopmentFirstBuyerStep_form$ref;
export type DevelopmentFirstBuyerStep_form = {|
  +id: string,
  +completed: boolean,
  +phoneNumber: ?string,
  +firstBuyerNationality: ?{|
    +id: string,
    +label: string,
    +name: string,
  |},
  +firstBuyerOccupation: ?{|
    +id: string,
    +label: string,
  |},
  +firstBuyerWorkPermit: ?{|
    +id: string,
    +label: string,
  |},
  +firstBuyerFirstName: ?string,
  +firstBuyerLastName: ?string,
  +firstBuyerDateOfBirth: ?string,
  +firstBuyerEmailAddress: ?string,
  +firstBuyerPhoneNumber: ?string,
  +firstBuyerAnnualRevenues: ?number,
  +firstBuyerSavings: ?number,
  +numberOfBuyers: ?number,
  +isAlreadyOwner: ?boolean,
  +secondBuyerFirstName: ?string,
  +secondBuyerLastName: ?string,
  +step: ?DevelopmentRegistrationStep,
  +product: ?{|
    +id: string
  |},
  +developmentProduct: ?{|
    +id: string,
    +products: $ReadOnlyArray<{|
      +id: string,
      +lotReference: ?string,
      +currency: ?LotCurrency,
      +salePrice: ?number,
      +status: string,
      +property: {|
        +id: string,
        +numberOfRooms: ?number,
        +floorOfFlat: ?number,
        +numberOfFloors: ?number,
      |},
    |}>,
  |},
  +$refType: DevelopmentFirstBuyerStep_form$ref,
|};
export type DevelopmentFirstBuyerStep_form$data = DevelopmentFirstBuyerStep_form;
export type DevelopmentFirstBuyerStep_form$key = {
  +$data?: DevelopmentFirstBuyerStep_form$data,
  +$fragmentRefs: DevelopmentFirstBuyerStep_form$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentFirstBuyerStep_form",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "firstBuyerNationality",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "firstBuyerOccupation",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "firstBuyerWorkPermit",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstBuyerFirstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstBuyerLastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstBuyerDateOfBirth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstBuyerEmailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstBuyerPhoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstBuyerAnnualRevenues",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstBuyerSavings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfBuyers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAlreadyOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondBuyerFirstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondBuyerLastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "step",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentProduct",
      "kind": "LinkedField",
      "name": "developmentProduct",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "products",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lotReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "salePrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Property",
              "kind": "LinkedField",
              "name": "property",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "numberOfRooms",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "floorOfFlat",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "numberOfFloors",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DevelopmentRegistrationForm",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '77143654377ef72ea48c4b67bc06fcc4';

export default node;
